import { render, staticRenderFns } from "./JdGiftBar.vue?vue&type=template&id=7f7c7fb4&"
import script from "./JdGiftBar.vue?vue&type=script&lang=js&"
export * from "./JdGiftBar.vue?vue&type=script&lang=js&"
import style0 from "./JdGiftBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports